/**
 * SeriesEndField — the end-condition input of a repeating schedule:
 * an end date, or a number of workshops, whichever end mode is chosen.
 */
import { DateField } from '../../primitives/DateField';
import { Field, fieldStyle, MONO } from '../../venues/venueCreateFields';

import type { WorkshopCreateForm } from './useWorkshopCreateForm';

export function SeriesEndField({ form }: { form: WorkshopCreateForm }) {
  const { draft, editSchedule, fieldError, minDate } = form;
  const s = draft.schedule;
  if (s.endMode === 'count') {
    return (
      <Field label="Workshops" required error={fieldError('occurrenceCount')}>
        <input
          type="number"
          aria-label="Number of workshops"
          className="nb-dt-input"
          min={2}
          max={52}
          step={1}
          style={fieldStyle(fieldError('occurrenceCount') ? 'error' : undefined, {
            fontFamily: MONO,
          })}
          value={s.occurrenceCount}
          onChange={(e) => editSchedule('occurrenceCount', e.target.value)}
        />
      </Field>
    );
  }
  return (
    <Field label="End date" required error={fieldError('untilDate')}>
      <DateField
        ariaLabel="End date"
        min={s.date || minDate}
        error={!!fieldError('untilDate')}
        value={s.untilDate}
        onChange={(v) => editSchedule('untilDate', v)}
      />
    </Field>
  );
}
